export default "__VITE_ASSET__58938513__"